import { render } from "./Composition.vue?vue&type=template&id=1300fa50"
import script from "./Composition.vue?vue&type=script&lang=js"
export * from "./Composition.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__